import clsx from 'clsx';
import { useEffect } from 'react';
import type { WidgetPlaceholderFragment } from 'lib/contentful/__generated__/ModuleWidgetPlaceholder';
import styles from './SprinkrlPlaceholder.module.scss';

export type SprinkrlPlaceholderProps = WidgetPlaceholderFragment;

export const SprinkrlPlaceholder = ({
  config,
  title,
}: SprinkrlPlaceholderProps) => {
  const sprinkrlId = (config as Record<string, unknown>)?.apiKey;
  const style = (config as Record<string, unknown>)?.style || {};

  if (!sprinkrlId) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const mainContent = document.body;

    const scriptId = `sprinklr-embed-loader-12046-${sprinkrlId}`;
    const script = document.querySelector(`#${scriptId}`);
    if (script) {
      mainContent?.removeChild(script);
    }
    const newScript = document.createElement('script');
    newScript.src = `https://gallery.sprinklr.com/clients/12046/embeds/${sprinkrlId}/script.js`;
    newScript.id = scriptId;
    newScript.defer = true;
    mainContent?.appendChild(newScript);
  }, [sprinkrlId]);

  return (
    <div className={styles.container} style={style}>
      {title && (
        <h2
          className={clsx(
            styles.title,
            'text-heading-h2-mobile',
            'text-heading-h2-desktop'
          )}
        >
          {title}
        </h2>
      )}
      <div
        id={`sprinklr-embed-control-12046-${sprinkrlId}`}
        className="swe_embed_controls"
      />
      <div
        id={`sprinklr-embed-12046-${sprinkrlId}`}
        className="swe_embed"
        data-filter-product=""
        data-filter-variant=""
      />
    </div>
  );
};
